import { Injectable, inject } from "@angular/core";
import { ApiService } from "../api/api.service";
import { Observable } from "rxjs";
import { Certificate, CertificateDownload } from "../../interfaces/certificate";
import { Guid } from "../../types/guid";

@Injectable({
  providedIn: "root",
})
export class CertifcatesService {
  private readonly apiService = inject(ApiService);

  getCertificates(): Observable<Certificate[]> {
    return this.apiService.getRequest<Certificate[]>(`certificates/`);
  }

  getCertificateDownload(id: Guid): Observable<CertificateDownload> {
    return this.apiService.getRequest<CertificateDownload>(
      `certificates/${id}/download/`,
    );
  }
}
